import React from 'react';
import { useTranslation } from '../i18n';
const DEMO_URL = 'https://calendar.app.google/kAzzsMuwfngdzNZf9';
export function FinalCTA() {
  const {
    t
  } = useTranslation();
  return <section className="relative py-32 overflow-hidden bg-[#050505] border-t border-white/5" data-id="element-29">
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-50" data-id="element-30">
        <div className="aurora-blob bg-[#CC00FF] w-[400px] h-[400px] top-[10%] left-[20%] animate-aurora-2" data-id="element-31"></div>
        <div className="aurora-blob bg-[#2563EB] w-[500px] h-[500px] bottom-[10%] right-[20%] animate-aurora-1" style={{
        animationDirection: 'reverse'
      }} data-id="element-32"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center" data-id="element-33">
        <h2 className="text-4xl md:text-6xl font-bold mb-8" data-id="element-34">
          {t('finalCTA.titlePart1')}
          <span className="text-gradient" data-id="element-35">{t('finalCTA.titleHighlight')}</span>.
        </h2>
        <p className="text-xl text-white/60 mb-12 max-w-2xl mx-auto" data-id="element-36">
          {t('finalCTA.desc')}
        </p>
        <a href={DEMO_URL} target="_blank" rel="noopener noreferrer" className="inline-block bg-gradient-animated rounded-full px-10 py-5 text-lg font-bold text-white hover:scale-105 transition-transform duration-300 shadow-[0_0_40px_rgba(0,229,255,0.3)]" data-id="element-37">
          {t('finalCTA.cta')}
        </a>
      </div>
    </section>;
}